import { render, staticRenderFns } from "./ProconNumberOfComplaints.vue?vue&type=template&id=2a87cee6&"
import script from "./ProconNumberOfComplaints.vue?vue&type=script&lang=ts&"
export * from "./ProconNumberOfComplaints.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports